// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__d2EYW","spin":"Loader_spin__lJ9JZ"};